import { Image } from '@/atoms/Image'
import { ParagraphXL } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'
import { DavidGoalProgress } from './DavidGoalProgress'

interface HelpLightSectionProps {
  releaseDate?: string
}

export function HelpLightSection({ releaseDate }: HelpLightSectionProps) {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full bg-[#48c7d8] px-[16px] pb-[96px] pt-[80px] md:flex md:items-center md:px-[64px] md:py-[160px]">
      <div className="mx-auto w-full max-w-[1440px] md:flex md:flex-row-reverse md:items-center">
        {/* Image Column - Shows at top on mobile, right side on desktop */}
        <div className="relative mb-8 flex w-full items-center justify-center md:mb-0 md:h-auto md:min-h-[600px] md:w-1/2 md:flex-[1_0_0]">
          <Image
            alt="David with his lamb"
            className="object-contain"
            src="/v1760542706/theatrical/david/david-tali-isolated-characters.png"
            width={692}
            height={692}
            sizes="(max-width: 768px) 370px, 692px"
          />
        </div>

        {/* Content Column - Shows below image on mobile, left side on desktop */}
        <div className="flex w-full flex-col items-start justify-center gap-[40px] md:w-1/2 md:flex-[1_0_0]">
          <div className="relative flex w-full flex-col items-start gap-[12px]">
            <p className="font-angel-royal relative w-full text-[40px] lowercase not-italic leading-[40px] text-[#141447] md:text-[64px] md:leading-[64px]">
              {t('davidHelpLightTitle', 'Help Light up Theaters Dec. 19')}
            </p>
            <ParagraphXL
              face="whitney"
              weight="medium"
              className="font-whitney-medium relative w-full text-[16px] not-italic leading-[24px] text-[#141447] md:text-[18px] md:leading-[28px]"
            >
              {t(
                'davidHelpLightDescription',
                'Your support helps put DAVID on more screens this Christmas—making room for families to encounter a story of faith, courage, and hope where it matters most.',
              )}
            </ParagraphXL>
          </div>

          <DavidGoalProgress
            releaseDate={releaseDate}
            textColor="#141447"
            progressBarBg="bg-white"
            progressBarBorder="border-white"
            progressBarFillBg="bg-[#141447]"
            textSize="md"
            shouldAnimateOnScroll={true}
          />

          <div className="relative flex w-full flex-col items-center gap-[8px] md:flex-row md:items-start">
            <DavidButton variant="dark" openPifOverlay className="w-full md:w-auto">
              {t('payItForward', 'Pay it Forward')}
            </DavidButton>
            <DavidButton variant="beige" href="/tickets/david" className="w-full md:w-auto">
              {t('getShowtimes', 'Get Showtimes')}
            </DavidButton>
          </div>
        </div>
      </div>
    </section>
  )
}
